import { Component, EventEmitter, Output, ViewChild, TemplateRef, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-status-modal',
  templateUrl: './status-modal.component.html',
  styleUrls: ['./status-modal.component.scss']
})
export class StatusModalComponent {
  public modalOpen: boolean = false;
  public status: number;
  public data: any;

  @ViewChild("statusModal", { static: false }) StatusModal: TemplateRef<any> | undefined;
  @Output() confirmedStatus: EventEmitter<any> = new EventEmitter();

  public statuses = [
    { value: 0, label: 'Draft', class: 'bg-dark text-white' },
    { value: 10, label: 'Publish', class: 'bg-success text-white' },
    { value: 99, label: 'Archived', class: 'bg-warning text-dark' }
  ];

  constructor(private modalService: NgbModal) { }

  openModal(data: any) {
    this.data = data;
    this.status = data.postStatus;
    this.modalOpen = true;
    this.modalService.open(this.StatusModal, {
      ariaLabelledBy: 'Status-Modal',
      centered: true,
      windowClass: 'theme-modal text-center'
    }).result.then((result) => {
      // Result handled in confirm/dismiss
    }, (reason) => {
      this.modalOpen = false;
    });
  }

  confirm() {
    this.confirmedStatus.emit({ data: this.data, status: this.status });
    this.modalService.dismissAll();
    this.modalOpen = false;
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }
}
